module.exports = __webpack_public_path__ + "0ddf282b48d87061f92c5ef211ccc5b9.glb";